
const userSetting = {
    methods: {

        ShotName(user) {
            var middleName = user.middleName?
                                                user.middleName.split('')[0]+'.'
                                                :'';
            return  user.lastName + ' ' +   user.firstName.split('')[0] + '.' + middleName

        },
        // fullName(user){
        //         var middleName = user.middleName?
        //                                             user.middleName+' '
        //                                             :'';
        //         return  user.lastName + ' ' + user.firstName + ' ' + middleName
        // },

        fullName(user) {
            // Если текущий язык английский, подставляем имя на англ
            if (this.$i18n.locale == "en") {
                // Если имя на англ пустое, используем рус имя
                if (this.user.first_name_en)
                    if (this.user.middle_name_en)
                        return `${this.user.last_name_en} ${this.user.first_name_en} ${this.user.middle_name_en}`;
                    else
                        return `${this.user.last_name_en} ${this.user.first_name_en}`;
                else
                    if (this.user.middle_name_en)
                        return `${this.user.lastName} ${this.user.firstName} ${this.user.middle_name_en}`;
                    else
                        return `${this.user.lastName} ${this.user.firstName}`;
            } else
                return `${this.user.lastName} ${this.user.firstName} ${this.user.middleName}`;
        },

        fullNameT(user){
                var middleName = user.middle_name?
                                                    user.middle_name+' '
                                                    :'';
                return  user.last_name + ' ' + user.first_name + ' ' + middleName
        },

        ShotNameT(user) {
            var middleName = user.middle_name?
                                                user.middle_name.split('')[0]+'.'
                                                :'';
            return  user.last_name + ' ' +   user.first_name.split('')[0] + '.' + middleName

        },


//open chat user
        userMessage(uid) {
            this.$router.push({name: 'chat', query: {user: uid}})
        },

//open profile
        userInfo(uid) {
            this.$router.push({name: 'user-info', query: {id: uid}})
        }


    }
  }

export default userSetting;
